// ─────────────────────────────────────────────────────────────────────────────
// V2 — see AUTH_CONTAINER_V2_PLAN.md
// V1 exports (AuthContainer, AuthModal) remain below during the migration.
// ─────────────────────────────────────────────────────────────────────────────
export {
  AuthContainerV2,
  AUTH_SUCCESS_EVENT,
  PAYWALL_UNLOCKED_EVENT,
  loginUrlFor,
  resolveReturnUrl,
  emitAuthSuccess,
  emitPaywallUnlocked,
} from './v2';
export type {
  AuthContainerV2Props,
  AuthSurface,
  AuthMethod,
  AuthAction,
  AuthSuccessEventDetail,
  PaywallUnlockedEventDetail,
  LoginUrlOptions,
  ResolveReturnUrlInput,
  ResolveReturnUrlResult,
} from './v2';

// ─────────────────────────────────────────────────────────────────────────────
// V1 (legacy) — consumers should migrate to V2 surfaces
// ─────────────────────────────────────────────────────────────────────────────
export { AuthContainer } from './components/AuthContainer';
export { AuthPortal } from './components/AuthPortal';
export { Upsell } from './components/Upsell';

export { AuthModal } from './components/AuthModal';
export type { AuthModalProps } from './components/AuthModal';

export { Login } from './components/Login';
export type { LoginProps } from './components/Login';

export { Register } from './components/Register';
export type { RegisterProps } from './components/Register';

export { OneSignalScript } from './components/OneSignalScript';
export { GOOGLE_SITE_KEY } from './config';

export type { PaywallContentType } from './components/AuthIterations/types';

export { PushSubscriber } from './components/PushSubscriber';
export type { PushSubscriberLabels, PushSubscriberProps } from './components/PushSubscriber';

export { SMSVerify } from './components/SMSVerify';
export type { OTPProps } from './components/SMSVerify';

export { handlePaywallLoginRedirect } from './utils/paywallUtils';
